module.exports = __webpack_public_path__ + "img/value_mock.1c46953d.png";